'use client'

import { createContext, useContext } from 'react'

const StorefrontContext = createContext<string | null | undefined>(undefined)

export const StorefrontIdProvider = ({
  children,
  storefrontId,
}: {
  children: React.ReactNode
  storefrontId: string | null | undefined
}) => {
  return (
    <StorefrontContext.Provider value={storefrontId}>
      {children}
    </StorefrontContext.Provider>
  )
}

export const useStorefrontId = (): string | null | undefined => {
  return useContext(StorefrontContext)
}
